import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-modal w-maxC" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = {
  key: 1,
  class: "w-full"
}
const _hoisted_4 = { class: "contactInputGrid mtop-15" }
const _hoisted_5 = { style: {"grid-column":"left","justify-self":"end","margin-top":"0.45rem"} }
const _hoisted_6 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_7 = { style: {"grid-column":"left","justify-self":"end","margin-top":"1.6rem"} }
const _hoisted_8 = {
  style: {"grid-column":"right"},
  class: "row"
}
const _hoisted_9 = { style: {"grid-column":"left","justify-self":"end","margin-top":"0.45rem"} }
const _hoisted_10 = {
  style: {"grid-column":"right"},
  class: "row"
}

import { ref, onMounted, onUnmounted } from 'vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import relationshipapi from "@/api/relationshipapi";
import { findById } from '@/functions/expression';


export default /*@__PURE__*/_defineComponent({
  __name: 'accidentInput',
  props: {
  accident: {
    type: Object,
    required: false,
  },
  cns: {
    type: Object,
    required: false,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props
const currentEntryStore = useCurrentEntryStore();
const emits = __emit;
const focusRef = ref(null);

async function deleteLuCnsAccident() {
  if (!props.accident) return;
  noUpdate.value = false
  const accidentId = props.accident.cnsWorkAccidentId
  await relationshipapi.deleteLuCnsWorkAccident(accidentId)
  await currentEntryStore.reloadPatientOnly();
  emits("close")  
}

const initialAccidentDate = ref(props.accident?.accidentDate || new Date().toString())
const currentAccidentDate = ref(initialAccidentDate.value)
function changeAccidentDate(newIso: string) {
  currentAccidentDate.value = newIso
}
async function updateLuCnsAccidentDate() {
  if (initialAccidentDate.value === currentAccidentDate.value) return false;
  const accidentId = props.accident.cnsWorkAccidentId
  const newText = currentAccidentDate.value
  await relationshipapi.updateLuCnsAccidentDate(accidentId, newText).then(() => {
    let accident = findById(currentEntryStore.modalPatient.cnsHealthInsurance.cnsWorkAccidents, "cnsWorkAccidentId", props.accident.cnsWorkAccidentId)
    accident.accidentDate = currentAccidentDate.value;
  })
  return true;
}

const accidentNumberInput = ref(props.accident?.accidentNumber || `U${new Date().getFullYear()}/`)
async function updateLuCnsAccidentNumber() {
  if (props.accident.accidentNumber === accidentNumberInput.value) return false;
  const accidentId = props.accident.cnsWorkAccidentId
  const newText = accidentNumberInput.value
  await relationshipapi.updateLuCnsAccidentNumber(accidentId, newText).then(() => {
    let accident = findById(currentEntryStore.modalPatient.cnsHealthInsurance.cnsWorkAccidents, "cnsWorkAccidentId", props.accident.cnsWorkAccidentId)
    accident.accidentNumber = accidentNumberInput.value;
  })
  return true;
}


const accidentDescriptionInput = ref(props.accident?.accidentDescription || "")
async function updateLuCnsAccidentDescription() {
  if (props.accident.accidentDescription === accidentDescriptionInput.value) return false;
  const accidentId = props.accident.cnsWorkAccidentId
  const newText = accidentDescriptionInput.value
  await relationshipapi.updateLuCnsAccidentDescription(accidentId, newText).then(() => {
    let accident = findById(currentEntryStore.modalPatient.cnsHealthInsurance.cnsWorkAccidents, "cnsWorkAccidentId", props.accident.cnsWorkAccidentId)
    accident.accidentDescription = accidentDescriptionInput.value;
  })
  return true;
}


async function addLuCnsAccident() {
  if (props.accident) return;
  const relationshipId = props.cns.relationshipId
  const accidentDate = currentAccidentDate.value
  const accidentNumber = accidentNumberInput.value
  const accidentDescription = accidentDescriptionInput.value
  await relationshipapi.addLuCnsWorkAccidentToInsurance(relationshipId, accidentDate, accidentNumber, accidentDescription)
  await currentEntryStore.reloadPatientOnly();
  emits("close")
}

onMounted(() => {
  focusRef.value.innerRef.focus()
})

const noUpdate = ref(false)
onUnmounted(async () => {
  if (noUpdate.value || !props.accident) return;
  let updated = false
  updated = await updateLuCnsAccidentNumber() || updated
  updated = await updateLuCnsAccidentDescription() || updated
  updated = await updateLuCnsAccidentDate() || updated
  if (updated) await currentEntryStore.reloadPatientOnly();
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_inputNewDate = _resolveComponent("inputNewDate")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_text_item, {
          txt: "Accident de travail",
          styles: "font-l"
        })
      ]),
      (props.accident)
        ? (_openBlock(), _createBlock(_component_buttonGroup, {
            key: 0,
            styles: "rnd-m",
            class: "mleft-08",
            style: {"margin-top":"-0.2rem"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteLuCnsAccident()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_svg_item, {
                icon: "trash",
                styles: "main-l"
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_buttonGroup, {
              class: "padButton-m",
              styles: "border-h",
              style: {"margin-left":"auto"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (addLuCnsAccident()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: "Créer",
                  styles: "font-mBold main-h"
                })
              ]),
              _: 1
            })
          ]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_text_item, {
          txt: "Numéro accident",
          styles: "main-m"
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputLineNew2, {
              ref_key: "focusRef",
              ref: focusRef,
              modelValue: accidentNumberInput.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((accidentNumberInput).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_text_item, {
          txt: "Date de l'accident",
          styles: "main-m"
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_inputNewDate, {
          dateIso: initialAccidentDate.value,
          isNew: !__props.accident?.accidentDate,
          calendar: false,
          trash: false,
          onChanged: changeAccidentDate
        }, null, 8, ["dateIso", "isNew"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_text_item, {
          txt: "Description",
          styles: "main-m"
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_inputBox, null, {
          default: _withCtx(() => [
            _createVNode(_component_inputAreaAuto2, {
              modelValue: accidentDescriptionInput.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((accidentDescriptionInput).value = $event)),
              lines: 3
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mtop-04" }, null, -1))
  ]))
}
}

})